export default "__VITE_ASSET__rUZrFjta__"